module.exports = __webpack_public_path__ + "img/fira-image-d.75bd7ebe.png";